export const GET_NIF_LIST = '/api/nif/get-all-nifs';
export const DOWNLOAD_NIF_FORM = '/api/nif/download-nif';
